import { render, staticRenderFns } from "./LocaleLanguage.vue?vue&type=template&id=444fab17&"
import script from "./LocaleLanguage.vue?vue&type=script&lang=ts&"
export * from "./LocaleLanguage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports